<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.PURCHASES.MINIMUM_WEIGHT' | translate }}</div>
  </ion-label>

  <ion-note slot="end">
    {{ minimWeight }} KG
  </ion-note>

</ion-item>

<ion-item>

  <ion-label>
    <div class="title">{{ 'ITEMS.PURCHASES.TOTAL_WEIGHT' | translate }}</div>

    @if (minimWeight > totalWeight) {
      <yu-helper icon="warning" color="error">
        {{ 'ITEMS.PURCHASES.MINIMUM_WEIGHT_NOT_REACHED' | translate }}
      </yu-helper>
    }
  </ion-label>

  <ion-note class="total-weight" slot="end">
    {{ totalWeight }} KG
  </ion-note>

</ion-item>
